import { api } from "./core";

// Testrule API for database assertions bound to one TestJob.
export const ruleApi = {
  listAll() {
    return api("/api/testrules");
  },

  list(jobId) {
    return api(`/api/testjobs/${jobId}/testrules`);
  },

  create(jobId, payload) {
    return api(`/api/testjobs/${jobId}/testrules`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  update(id, payload) {
    return api(`/api/testrules/${id}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  run(id) {
    return api(`/api/testrules/${id}/run`, { method: "POST" });
  },

  shareTemplate(id) {
    return api(`/api/testrules/${id}/share-template`, { method: "POST" });
  },

  test(payload) {
    return api("/api/testrules/run", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  remove(id) {
    return api(`/api/testrules/${id}`, { method: "DELETE" });
  },
};
